// extracted by mini-css-extract-plugin
module.exports = {"createButton":"CreateShipstationSetting_createButton__2xYgU"};